module.exports = {"460321451":"永兴","460321452":"永乐","460321453":"七连屿"}


//////////////////
// WEBPACK FOOTER
// ./src/town/460321.json
// module id = 2321
// module chunks = 0